import BookYourStayForm from 'routes/DateSelection/components/BookYourStayForm';
import { connect } from 'react-redux';
import {
  setNumberOfGuests,
  onStartDateChange,
  onEndDateChange
} from 'routes/DateSelection/reducer';
import { createStructuredSelector } from 'reselect';
import {
  endDateSelector,
  numberOfGuestsSelector,
  propertySelector,
  queryInputSelector,
  startDateSelector,
  isWaitListBookingSelector
} from 'routes/DateSelection/selectors';
import { roomTypeSelector } from 'routes/ChooseAccommodation/selectors';
import { updateFilters } from 'routes/ChooseAccommodation/reducer';
import { bookingSourceSelector } from 'routes/selectors';

const mapStateToProps = createStructuredSelector({
  property: propertySelector,
  startDate: startDateSelector,
  endDate: endDateSelector,
  roomType: roomTypeSelector,
  numberOfGuests: numberOfGuestsSelector,
  queryInput: queryInputSelector,
  bookingSource: bookingSourceSelector,
  isWaitListBooking: isWaitListBookingSelector
});

function mapDispatchToProps(dispatch) {
  return {
    onRoomTypeChange: roomType => dispatch(updateFilters({ roomType })),
    onNumGuestsChange: numberOfGuests =>
      dispatch(setNumberOfGuests(numberOfGuests)),
    onStartDateChange: date => dispatch(onStartDateChange(date)),
    onEndDateChange: date => dispatch(onEndDateChange(date))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookYourStayForm);
